var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScholarshipAgreementsSectionTitleWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 30,
    viewBox: "0 0 46 32.206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "graduation-cap-solid_1_",
    "data-name": "graduation-cap-solid (1)",
    d: "M22.985,32a5.085,5.085,0,0,0-1.7.295L1.121,39.575a1.73,1.73,0,0,0,0,3.249l4.161,1.5A11.832,11.832,0,0,0,3.436,50.68V52.7a13.635,13.635,0,0,1-1.6,5.807,19.055,19.055,0,0,1-1.617,2.7,1.153,1.153,0,0,0,.64,1.811l4.6,1.15a1.146,1.146,0,0,0,.891-.144,1.126,1.126,0,0,0,.51-.747,18.53,18.53,0,0,0-.151-7.813,15.894,15.894,0,0,0-.97-3.019V50.68a9.544,9.544,0,0,1,2.005-5.858,8.776,8.776,0,0,1,3.536-2.566l11.284-4.435a1.147,1.147,0,0,1,.841,2.135L12.118,44.391A6.6,6.6,0,0,0,9.8,45.943l11.471,4.14a5.071,5.071,0,0,0,3.407,0l20.168-7.259a1.73,1.73,0,0,0,0-3.249l-20.16-7.281A5.085,5.085,0,0,0,22.985,32ZM9.185,59.024c0,2.537,6.181,5.175,13.8,5.175s13.8-2.638,13.8-5.175l-1.1-10.45-10.22,3.694a7.345,7.345,0,0,1-4.959,0l-10.22-3.694Z",
    transform: "translate(0.015 -32)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScholarshipAgreementsSectionTitleWhiteIcon);
export default __webpack_public_path__ + "static/media/scholarship-agreements-section-title-white-icon.76cb33482a154010db1325b5971befb6.svg";
export { ForwardRef as ReactComponent };